


































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { ValidationObserver } from 'vee-validate';

import api, { apiSandbox } from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import FileIcon from 'mdi-vue/File';
import DownloadIcon from 'mdi-vue/Download';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';

import { Division, Service } from '@/libs/api.interfaces';

import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import MerchantLeadTable from './MerchantLeadTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    SearchIcon,
    FileIcon,
    DownloadIcon,
    SearchRow,
    SearchField,
    Select,
    MerchantLeadTable,
    Modal,
    FormInput,
    ValidationObserver,
    DatePicker,
  },
})
export default class MerchantLead extends Vue {
  searchOpen = false;
  month: LabelValue | null = null;
  year: LabelValue | null = null;
  status: LabelValue | null = null;

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  $refs!: {
    table: MerchantLeadTable;
  }

  selectedMerchants: { merchant_code: string; merchant_name: string } | null = null;
  selectedBrand: { merchant_brand: string } | null = null;
  loadingMerchant = false;
  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  brands = [];

  loadingService = false;
  services: Service[] = [];
  selectedService: Service | null = null;
  selectedServiceGenerate: Service | null = null;

  loadingDivision = false;
  divisions: Division[] = [];
  selectedDivisionGenerate: Division | null = null;

  months = [
    {
      label: 'All',
      value: '0',
    }, ...[...Array(12)].map((_, i) => ({
      label: dayjs().month(i).format('MMMM'),
      value: (i + 1).toString().padStart(2, '00'),
    })),
  ];

  years = [{
    label: 'All',
    value: '0',
  },
  ...[...Array(15)].map((_, i) => {
    const now = dayjs().subtract(i, 'year').format('YYYY');
    return {
      label: now,
      value: now,
    };
  }),
  ]

  statuses = [
    {
      label: 'All',
      value: '',
    }, {
      label: 'New Merchant',
      value: '0',
    }, {
      label: 'Potential Merchant',
      value: '2',
    },
  ]

  // modal
  showModal = false;
  loadingGenerate = false;
  loadingExport = false;
  selectedMerchantGenerate: { merchant_code: string; merchant_name: string } | null = null;
  monthFrom: LabelValue | null = null;
  yearFrom: LabelValue | null = null;
  monthTo: LabelValue | null = null;
  yearTo: LabelValue | null = null;
  monthsGenerate = this.months.slice(1);
  yearsGenerate = this.years.slice(1);

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  async mounted() {
    // this.getService();
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getMerchants(query: string, value: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const params: any = {};
      params[query] = value;
      const { data } = await apiSandbox.get('/consumer/merchant/lead', {
        params,
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
      console.log();
    } catch (err) {
      console.error(err);
    }
  }

  // async getService() {
  //   try {
  //     this.loadingService = true;
  //     const { data } = await api.get<Service[]>('/service');
  //     /* eslint-disable @typescript-eslint/camelcase */
  //     this.services = [{
  //       service_code: 'All',
  //       service_name: 'All',
  //       service_dbname: 'All',
  //     }, ...data];
  //     /* eslint-enable @typescript-eslint/camelcase */

  //     this.loadingService = false;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }

  search() {
    this.$router.push({
      query: {
        mc: this.selectedMerchants === null ? undefined : JSON.stringify(this.selectedMerchants),
        mt: this.month === null ? undefined : this.month.value,
        yr: this.year === null ? undefined : this.year.value,
        st: this.status === null ? undefined : this.status.value,
        sv: this.selectedService === null ? undefined : JSON.stringify(this.selectedService),
        td: this.transactionDate.startDate && this.transactionDate.endDate
          ? this.transactionDate && `${this.transactionDate.startDate},${this.transactionDate.endDate}` : undefined,
        br: this.selectedBrand === null ? undefined : JSON.stringify(this.selectedBrand),
      },
    });
  }

  cancel() {
    this.month = null;
    this.year = null;
    this.status = null;
    this.selectedMerchants = null;
    this.selectedService = null;
    this.selectedBrand = null;
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };

    this.$router.push({
      query: {},
    });
  }

  async getInvoice(page: number, isExport = false) {
    const params = {
      year: this.year,
      month: this.month,
      merchant: this.selectedMerchants,
      status: this.status,
      service: this.selectedService,
      transactionDate: this.transactionDate,
      brand: this.selectedBrand,
    };

    await this.$refs.table.getInvoice(params, page, isExport);
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.td === 'string') {
      const dates = params.td.split(',');
      this.transactionDate = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    } else {
      this.transactionDate = {
        startDate: null,
        endDate: null,
      };
    }

    if (typeof params.yr === 'string') {
      const year = this.years.find((e) => e.value === params.yr);
      if (year) {
        this.year = year;
      }
    } else {
      this.year = null;
    }

    if (typeof params.mt === 'string') {
      const month = this.months.find((e) => e.value === params.mt);
      if (month) {
        this.month = month;
      }
    } else {
      this.month = null;
    }

    if (typeof params.mc === 'string') {
      const merchant = JSON.parse(params.mc);
      this.selectedMerchants = merchant;
    } else {
      this.selectedMerchants = null;
    }

    if (typeof params.br === 'string') {
      const brand = JSON.parse(params.br);
      this.selectedBrand = brand;
    } else {
      this.selectedBrand = null;
    }

    if (typeof params.st === 'string') {
      const status = this.statuses.find((e) => e.value === params.st);
      if (status) {
        this.status = status;
      } else {
        this.status = null;
      }
    }

    if (typeof params.sv === 'string') {
      const service = JSON.parse(params.sv);
      if (service) {
        this.selectedService = service;
      } else {
        this.status = null;
      }
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getInvoice(page);
  }

  openGenerateModal() {
    this.showModal = true;
  }

  closeGenerateModal() {
    this.showModal = false;
  }

  async exportData() {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');
    this.loadingExport = true;
    // eslint-disable-next-line radix
    await this.getInvoice(this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1, true);
    this.loadingExport = false;
  }
}
